"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[808],{

/***/ 4780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ix": function() { return /* binding */ ONE_DAY_IN_MS; },
/* harmony export */   "Vd": function() { return /* binding */ ONE_HOUR_IN_MS; },
/* harmony export */   "mW": function() { return /* binding */ ONE_SEC_IN_MS; },
/* harmony export */   "sW": function() { return /* binding */ ONE_MIN_IN_MS; }
/* harmony export */ });
// ---- Times
var ONE_SEC_IN_MS = 1000;
var ONE_MIN_IN_MS = ONE_SEC_IN_MS * 60;
var ONE_HOUR_IN_MS = ONE_MIN_IN_MS * 60;
var ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24;


/***/ }),

/***/ 808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useQuery; }
});

// UNUSED EXPORTS: QueryStatus

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(3198);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ../wif-ui-lib/dist/index-615eb227.mjs
var index_615eb227 = __webpack_require__(8517);
// EXTERNAL MODULE: ../wif-ui-lib/dist/main.js
var main = __webpack_require__(128);
// EXTERNAL MODULE: ./src/constants/durations.ts
var durations = __webpack_require__(4780);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(2050);
;// CONCATENATED MODULE: ./src/util/web-cache.ts
// Native Cache for browsers.
// @mdn https://developer.mozilla.org/en-US/docs/Web/API/Cache



function getFromCache(request) {
    return _getFromCache.apply(this, arguments);
}
function _getFromCache() {
    _getFromCache = (0,_async_to_generator/* default */.Z)(function(request) {
        var cacheDurationInMs, cache, TIMESTAMP_KEY, cachedResponse, timestamp;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cacheDurationInMs = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0;
                    if (cacheDurationInMs <= 0) return [
                        2,
                        undefined
                    ];
                    return [
                        4,
                        openCacheForQuery()
                    ];
                case 1:
                    cache = _state.sent();
                    if (!cache) return [
                        2,
                        undefined
                    ];
                    TIMESTAMP_KEY = createQueryCacheTimestampKey(request.url);
                    return [
                        4,
                        cache.match(request.url)
                    ];
                case 2:
                    cachedResponse = _state.sent();
                    return [
                        4,
                        cache.match(TIMESTAMP_KEY).then(function(res) {
                            return res === null || res === void 0 ? void 0 : res.text();
                        }).then(function(value) {
                            return value ? Number(value) : 0;
                        })
                    ];
                case 3:
                    timestamp = _state.sent() || 0;
                    if (!cachedResponse) return [
                        3,
                        6
                    ];
                    if (!(Date.now() < timestamp)) return [
                        3,
                        4
                    ];
                    return [
                        2,
                        cachedResponse
                    ];
                case 4:
                    return [
                        4,
                        removeFromCache(request)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _getFromCache.apply(this, arguments);
}
function addToCache(request, response, cacheDuration) {
    return _addToCache.apply(this, arguments);
}
function _addToCache() {
    _addToCache = (0,_async_to_generator/* default */.Z)(function(request, response, cacheDuration) {
        var cache, TIMESTAMP_KEY;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        openCacheForQuery()
                    ];
                case 1:
                    cache = _state.sent();
                    if (!cache) return [
                        2
                    ];
                    TIMESTAMP_KEY = createQueryCacheTimestampKey(request.url);
                    return [
                        4,
                        Promise.all([
                            cache.put(request.url, response),
                            cache.put(TIMESTAMP_KEY, new Response((Date.now() + cacheDuration).toString()))
                        ])
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _addToCache.apply(this, arguments);
}
function removeFromCache(request) {
    return _removeFromCache.apply(this, arguments);
}
function _removeFromCache() {
    _removeFromCache = (0,_async_to_generator/* default */.Z)(function(request) {
        var cache, TIMESTAMP_KEY, ref, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        openCacheForQuery()
                    ];
                case 1:
                    cache = _state.sent();
                    if (!cache) return [
                        2
                    ];
                    TIMESTAMP_KEY = createQueryCacheTimestampKey(request.url);
                    return [
                        4,
                        Promise.all([
                            cache.delete(request, {
                                ignoreMethod: true,
                                ignoreSearch: true,
                                ignoreVary: true
                            }),
                            cache.delete(TIMESTAMP_KEY)
                        ])
                    ];
                case 2:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = ref[0];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _removeFromCache.apply(this, arguments);
}
function openCacheForQuery() {
    return _openCacheForQuery.apply(this, arguments);
}
function _openCacheForQuery() {
    _openCacheForQuery = (0,_async_to_generator/* default */.Z)(function() {
        var ref, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (true) return [
                        3,
                        1
                    ];
                    _tmp = undefined;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        window === null || window === void 0 ? void 0 : (ref = window.caches) === null || ref === void 0 ? void 0 : ref.open("query")
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    });
    return _openCacheForQuery.apply(this, arguments);
}
var TIMESTAMP_KEY = "+timestamp+";
/**
 * Timestamp should be stored separately as current
 * cache mechanism does not provide time of cache storage.
 */ function createQueryCacheTimestampKey(url) {
    return url + TIMESTAMP_KEY;
}
/** Check expired requests and clear them */ function clearExpiredCache() {
    return _clearExpiredCache.apply(this, arguments);
}
function _clearExpiredCache() {
    _clearExpiredCache = (0,_async_to_generator/* default */.Z)(function() {
        var cache, now, currentUrlHost, allRequests, toBeDeleted, i, req, timestampKey, timestamp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        openCacheForQuery()
                    ];
                case 1:
                    cache = _state.sent();
                    if (!cache) return [
                        2
                    ];
                    now = Date.now();
                    currentUrlHost = new URL(window.location.href).host;
                    return [
                        4,
                        cache.keys()
                    ];
                case 2:
                    allRequests = _state.sent();
                    toBeDeleted = [];
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < allRequests.length)) return [
                        3,
                        6
                    ];
                    req = allRequests[i];
                    // Only delete requests from the same host
                    if (!req.url.includes(currentUrlHost)) return [
                        3,
                        5
                    ];
                    // Ignore timestamp key as they will be deleted along with the request
                    if (req.url.includes(TIMESTAMP_KEY)) return [
                        3,
                        5
                    ];
                    timestampKey = createQueryCacheTimestampKey(req.url);
                    return [
                        4,
                        cache.match(timestampKey).then(function(res) {
                            return res === null || res === void 0 ? void 0 : res.text();
                        }).then(function(value) {
                            return value ? Number(value) : 0;
                        })
                    ];
                case 4:
                    timestamp = _state.sent();
                    if (timestamp < now) toBeDeleted.push(req);
                    _state.label = 5;
                case 5:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        4,
                        Promise.all(toBeDeleted.map(removeFromCache))
                    ];
                case 7:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _clearExpiredCache.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/hooks/useQuery.ts







var QueryStatus;
(function(QueryStatus) {
    QueryStatus["INIT"] = "init";
    QueryStatus["LOADING"] = "loading";
    QueryStatus["SUCCESS"] = "success";
    QueryStatus["ERROR"] = "error";
    QueryStatus["CANCELLED"] = "cancelled";
})(QueryStatus || (QueryStatus = {}));
function useQuery(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var queryUrl = url.toString();
    var initialData = options.initialData, _disabled = options.disabled, disabled = _disabled === void 0 ? false : _disabled, headers = options.headers, onLoading = options.onLoading, onSuccess = options.onSuccess, onError = options.onError, onDone = options.onDone, enableBackgroundFetch = options.enableBackgroundFetch, _refetchOnReconnect = options.refetchOnReconnect, refetchOnReconnect = _refetchOnReconnect === void 0 ? true : _refetchOnReconnect, cacheDurationInMs = options.cacheDurationInMs, _debounceDurationInMs = options.debounceDurationInMs, debounceDurationInMs = _debounceDurationInMs === void 0 ? 0 : _debounceDurationInMs;
    var abortControllerRef = (0,react.useRef)();
    var ref = (0,react.useTransition)(), startTransition = ref[1];
    var ref1 = (0,react.useState)(QueryStatus.INIT), status = ref1[0], setStatus = ref1[1];
    var ref2 = (0,react.useState)(initialData), data = ref2[0], setData = ref2[1];
    var ref3 = (0,react.useState)(undefined), errorMsg = ref3[0], setErrorMsg = ref3[1];
    var memoHeaders = (0,index_615eb227.d)(headers);
    var previousDataRef = (0,index_615eb227.c)(data);
    var handleLoading = (0,index_615eb227.a)(function(backgroundFetch) {
        startTransition(function() {
            setErrorMsg(undefined);
        });
        if (enableBackgroundFetch && Boolean(previousDataRef.current) || backgroundFetch) {
            return;
        }
        startTransition(function() {
            onLoading === null || onLoading === void 0 ? void 0 : onLoading();
            setStatus(QueryStatus.LOADING);
        });
    });
    var handleSuccess = (0,index_615eb227.a)(function(data) {
        startTransition(function() {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
            setData(data);
            setErrorMsg(undefined);
            setStatus(QueryStatus.SUCCESS);
        });
    });
    var handleError = (0,index_615eb227.a)(function(error) {
        startTransition(function() {
            setErrorMsg(error.message);
            var errorStatus = error.name === "AbortError" ? QueryStatus.CANCELLED : QueryStatus.ERROR;
            setStatus(errorStatus);
            if (errorStatus === QueryStatus.ERROR && onError) {
                onError(error);
            }
        });
    });
    var handleDone = (0,index_615eb227.a)(function() {
        return onDone === null || onDone === void 0 ? void 0 : onDone();
    });
    var initQuery = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(backgroundFetch) {
            var // cancel the previous request before new request
            ref, abortController, handleResponse, request;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (disabled) return [
                    2
                ];
                (ref = abortControllerRef.current) === null || ref === void 0 ? void 0 : ref.abort();
                abortController = new AbortController();
                abortControllerRef.current = abortController;
                handleLoading(backgroundFetch);
                handleResponse = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                        var status, data, data1;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    status = response.status;
                                    if (!(status >= 400)) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        response.json()
                                    ];
                                case 1:
                                    data = _state.sent();
                                    throw new Error(String(data) || response.statusText);
                                case 2:
                                    return [
                                        4,
                                        response.json()
                                    ];
                                case 3:
                                    data1 = _state.sent();
                                    if (abortController.signal.aborted) throw new DOMException("Aborted while handling response", "AbortError");
                                    return [
                                        2,
                                        data1
                                    ];
                            }
                        });
                    });
                    return function handleResponse(response) {
                        return _ref.apply(this, arguments);
                    };
                }();
                request = new Request(queryUrl, {
                    headers: memoHeaders,
                    signal: abortController.signal
                });
                fetchQueryWithCache(request, cacheDurationInMs).then(handleResponse).then(handleSuccess).catch(handleError).finally(handleDone);
                return [
                    2
                ];
            });
        });
        return function(backgroundFetch) {
            return _ref.apply(this, arguments);
        };
    }(), [
        disabled,
        queryUrl,
        memoHeaders,
        cacheDurationInMs,
        handleLoading,
        handleSuccess,
        handleError,
        handleDone, 
    ]);
    var cancelQuery = (0,react.useCallback)(function() {
        var ref;
        (ref = abortControllerRef.current) === null || ref === void 0 ? void 0 : ref.abort();
    }, []);
    // Initialise the query
    // Run query when it changes (+mount)
    (0,react.useEffect)(function() {
        var debouncedInitQuery = debounceDurationInMs ? lodash_debounce_default()(initQuery, debounceDurationInMs) : initQuery;
        debouncedInitQuery();
        return cancelQuery;
    }, [
        initQuery,
        cancelQuery,
        debounceDurationInMs
    ]);
    // Run when internet is reconnected
    (0,main/* useEventListener */.OR)("online", function() {
        return initQuery(true);
    }, !refetchOnReconnect);
    (0,main/* useInterval */.Yz)(function() {
        clearExpiredCache();
    }, durations/* ONE_MIN_IN_MS */.sW, {
        executeImmediately: true
    });
    return {
        status: status,
        data: data,
        errorMsg: errorMsg,
        refresh: initQuery,
        cancel: cancelQuery,
        isInit: status === QueryStatus.INIT,
        isSuccess: status === QueryStatus.SUCCESS,
        isError: status === QueryStatus.ERROR,
        isLoading: status === QueryStatus.LOADING,
        isDisabled: disabled
    };
}
function fetchQueryWithCache(request, cacheDurationInMs) {
    return _fetchQueryWithCache.apply(this, arguments);
}
function _fetchQueryWithCache() {
    _fetchQueryWithCache = (0,_async_to_generator/* default */.Z)(function(request, cacheDurationInMs) {
        var cachedResponse;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getFromCache(request, cacheDurationInMs)
                    ];
                case 1:
                    cachedResponse = _state.sent();
                    if (cachedResponse) return [
                        2,
                        cachedResponse
                    ];
                    // Fetching new data since the cache does not exist or is expired.
                    return [
                        2,
                        fetch(request).then(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(response.ok && cacheDurationInMs)) return [
                                                3,
                                                2
                                            ];
                                            // Response can be only used once, so it is cloned here.
                                            return [
                                                4,
                                                addToCache(request, response.clone(), cacheDurationInMs)
                                            ];
                                        case 1:
                                            _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2,
                                                response
                                            ];
                                    }
                                });
                            });
                            return function(response) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
            }
        });
    });
    return _fetchQueryWithCache.apply(this, arguments);
}


/***/ })

}]);